import { memo } from "react"

import styled, { css } from "styled-components"

import { borderRadius, colors, spacing, typography, size, elevation } from "@izettle/otto"

import {
  ZINDEX_SELECT_LIST,
  ZINDEX_SELECT_LIST_FULLSCREEN,
  FOCUS_BORDER_WIDTH,
} from "../helpers/constants"

const mixinIsExpanded = css<{ isExpanded?: boolean }>`
  ${({ isExpanded }) =>
    isExpanded
      ? `
      opacity: 1;
    `
      : `
      opacity: 0;
      transform: translateY(${spacing.xxSmall});
      pointer-events: none;
    `}
`

export const SelectListPlacement = memo(styled.div`
  position: relative;
  width: 100%;
  z-index: ${ZINDEX_SELECT_LIST};
`)

/* Here z-index is set to 20, to be above the FloatingLabels of adjacent components */
export const SelectListContainer = memo(styled.div<{
  isExpanded?: boolean
  isLoading?: boolean
  hasActions?: boolean
}>`
  ${typography.regular}
  margin: 0;
  max-width: 100%;
  max-height: 300px;
  overflow-y: scroll;
  background: ${colors.background.default};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: ${spacing.xSmall} 0;
  border-radius: ${borderRadius.large};
  box-shadow: ${elevation.level3};
  transition:
    opacity 0.2s,
    transform 0.2s;
  min-height: ${size.large};
  position: absolute;
  /* The border is always in focus state when open. */
  width: calc(100% + ${FOCUS_BORDER_WIDTH} * 2);
  ${mixinIsExpanded}
  ${({ isLoading }) =>
    isLoading &&
    `
      cursor: progress;
    `}
  ${({ hasActions }) =>
    hasActions &&
    `
      padding-bottom: 0;
    `}
`)

export const SelectListMobile = memo(styled.div<{ isExpanded?: boolean }>`
  position: fixed;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(100% - ${spacing.xSmall});
  background: ${colors.background.default};
  transition:
    opacity 0.2s,
    transform 0.2s;
  display: flex;
  flex-direction: column;
  padding: ${spacing.xSmall} 0 0 0;
  z-index: ${ZINDEX_SELECT_LIST_FULLSCREEN};
  align-self: flex-end;
  ${mixinIsExpanded}
`)

export const SelectListContent = memo(styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
`)

export const ChildrenContainer = memo(styled.div`
  overflow-y: scroll;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
`)

export const ButtonContainer = memo(styled.div`
  box-sizing: border-box;
  padding: ${spacing.xSmall};
  width: 100%;
  align-self: flex-end;
  max-height: fit-content;
  display: flex;
  flex-direction: column;
`)

export const LabelContainer = memo(styled.div`
  padding: ${spacing.xSmall};
  text-overflow: ellipsis;
  overflow: hidden;
  ${typography.title2}
`)

export const FocusTrap = memo(styled.button`
  max-width: 0;
  max-height: 0;
  opacity: 0;
`)
